module.exports = __webpack_public_path__ + "assets/img/img_2024.86b30c79.png";